import {AppForm} from "../../../../../../../common/forms/app.form";
import {Injectable} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite} from "../../../../../../../openapi";

@Injectable()
export class CurrentResidentialAddressForm extends AppForm {
  constructor() {
    super({
      changeCurrentAddress: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),

      changeCurrentAddressCity: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeCurrentAddressPostalCode: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeCurrentAddressStreet: new FormControl({value: '', disabled: true}, {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      changeCurrentAddressHouseNumber: new FormControl({value: '', disabled: true}, {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      changeCurrentAddressApartmentNumber: new FormControl({value: '', disabled: true}, Validators.maxLength(255)),

      changeCurrentAddressCoOwner: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
      changeCurrentAddressCoOwnerData: new FormControl({value: '', disabled: true}, {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
    });
  }

  private get changeCurrentAddressCity(): FormControl {
    return this.get('changeCurrentAddressCity') as FormControl;
  }

  private get changeCurrentAddressPostalCode(): FormControl {
    return this.get('changeCurrentAddressPostalCode') as FormControl;
  }

  private get changeCurrentAddressStreet(): FormControl {
    return this.get('changeCurrentAddressStreet') as FormControl;
  }

  private get changeCurrentAddressHouseNumber(): FormControl {
    return this.get('changeCurrentAddressHouseNumber') as FormControl;
  }

  private get changeCurrentAddressApartmentNumber(): FormControl {
    return this.get('changeCurrentAddressApartmentNumber') as FormControl;
  }

  private get changeCurrentAddressCoOwnerData(): FormControl {
    return this.get('changeCurrentAddressCoOwnerData') as FormControl;
  }

  public changeCurrentAddressChange(v: boolean) {
    if (!v) {
      this.changeCurrentAddressCity?.reset();
      this.changeCurrentAddressCity?.disable();

      this.changeCurrentAddressPostalCode?.reset();
      this.changeCurrentAddressPostalCode?.disable();

      this.changeCurrentAddressStreet?.reset();
      this.changeCurrentAddressStreet?.disable();

      this.changeCurrentAddressHouseNumber?.reset();
      this.changeCurrentAddressHouseNumber?.disable();

      this.changeCurrentAddressApartmentNumber?.reset();
      this.changeCurrentAddressApartmentNumber?.disable();
    } else {
      this.changeCurrentAddressCity?.enable();
      this.changeCurrentAddressPostalCode?.enable();
      this.changeCurrentAddressStreet?.enable();
      this.changeCurrentAddressHouseNumber?.enable();
      this.changeCurrentAddressApartmentNumber?.enable();
    }
  }

  public changeCurrentAddressCoOwnerChange(v: boolean) {
    if (!v) {
      this.changeCurrentAddressCoOwnerData?.reset();
      this.changeCurrentAddressCoOwnerData?.disable();
    } else {
      this.changeCurrentAddressCoOwnerData?.enable();
    }
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      changeCurrentAddressCity: this.value.changeCurrentAddressCity || null,
      changeCurrentAddressPostalCode: this.value.changeCurrentAddressPostalCode || null,
      changeCurrentAddressStreet: this.value.changeCurrentAddressStreet || null,
      changeCurrentAddressHouseNumber: this.value.changeCurrentAddressHouseNumber || null,
      changeCurrentAddressApartmentNumber: this.value.changeCurrentAddressApartmentNumber || null
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.changeCurrentAddressChange(!!value?.changeCurrentAddress);
    this.changeCurrentAddressCoOwnerChange(!!value?.changeCurrentAddressCoOwner);
    super.patchFormValues(value);
  }
}
